export default __webpack_public_path__ + "static/media/32t.69204752.jpg";